var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-wrapper"},[_c('div',{staticClass:"test-form-box"},[_c('SyForm',{attrs:{"config":_vm.config},on:{"getData":_vm.getData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }